import {
  GET_VENDORSTORE_BEGIN,
  GET_VENDORSTORE_SUCCESS,
  GET_VENDORSTORE_FAIL
} from '../action/vendorstoreAction'

const initialState = {
  loading: false,
  storeresults: null,
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_VENDORSTORE_BEGIN:
      return {
        loading: true,
        error: null
      }
    case GET_VENDORSTORE_SUCCESS:
      return {
        loading: false,
        storeresults: action.payload.data
      }
    case GET_VENDORSTORE_BEGIN:
      return {
        loading: false,
        error: action.payload.error
      } 
    default:
      return state
  }
}